import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { CommercePaymentMethodForm, CommerceQuotationForm } from './StepFourFormProvider';
import { CommerceQuotationComponent, CommerceQuotationRequest, WebCommerceQuotation } from '../../../../../../../../../shared/interfaces/services';
import { FireQuotationRequest } from '../../../../../../../../../shared/interfaces/services/fire-quotation-service';
import { GetCommertialsConditionsResponse } from '../../../../../../../../../shared/interfaces';

import { QuotationButton } from '../../../../../shared';

interface StepFourFormContextProps {
  activeTab:                        any;
  clearPrimaFieldsOnFormChange:     () => void;
  commercePaymentMethodsForm:       FormInstance<CommercePaymentMethodForm>;
  commerceQuotationComponents:      Array<CommerceQuotationComponent>;
  commertialConditions:             GetCommertialsConditionsResponse | undefined;
  createTabs:                       () => void;
  generateCommerceQuotationForm:    () => CommerceQuotationRequest;
  handlerOnClick:                   () => Promise<void>;
  handlerOnClickQuotation:          (form: FireQuotationRequest) => Promise<void>;
  labelButton:                      QuotationButton;
  quotationResponse?:               WebCommerceQuotation;
  quotationTabs:                    Array<any>;
  setActiveTab:                     Dispatch<SetStateAction<any>>;
  setLabelButton:                   Dispatch<SetStateAction<QuotationButton>>;
  setQuotationResponse:             Dispatch<SetStateAction<WebCommerceQuotation | undefined>>;
  setQuotationTabs:                 Dispatch<SetStateAction<Array<any>>>;
  stepFourCommerceQuotationForm:    FormInstance<CommerceQuotationForm>;
}

export const StepFourFormContext = createContext(
  {} as StepFourFormContextProps
);
